import React from 'react'
import {Outlet} from "react-router-dom";
import Nav from "../components/Landing/Nav";
import Footer from "../components/Landing/Footer";

const CourseLayout = () => {
  return (
    <div>
      <Nav isTextWhite={false} />
        <Outlet/>
      <Footer />
    </div>
  )
}

export default CourseLayout;
